module.exports = __webpack_public_path__ + "static/media/do-the-right.6c754909.svg";